Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Home = function Home(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ['color', 'size']);

  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 27 27',
      fill: color,
      fillRule: 'evenodd',
      stroke: 'none',
      strokeWidth: '1',
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    }, otherProps),
    _react2.default.createElement('path', { d: 'M14.7860585,4.57507987 L22.8167109,13.1373802 C23.2021822,13.456869 22.9452013,14.0958466 22.3669943,14.0958466 L20.503883,14.0958466 L20.503883,22.2108626 C20.503883,23.1693291 19.7329403,24 18.7692621,24 L15.3642654,24 L15.3642654,17.8019169 L11.5737975,17.8019169 L11.5737975,24 L8.23304611,24 C7.26936782,24 6.43417997,23.1693291 6.43417997,22.2108626 L6.43417997,14.0958466 L4.57106861,14.0958466 C4.05710686,14.0958466 3.80012598,13.456869 4.1855973,13.1373802 L12.2162497,4.57507987 C12.9229471,3.80830671 14.0793611,3.80830671 14.7860585,4.57507987 Z' }),
  );
};

Home.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Home.defaultProps = {
  color: 'currentColor',
  size: '24'
};

exports.default = Home;